import * as React from 'react';
import { FC, useState } from 'react';

import { Box, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { FavoriteInput } from 'components/favorite-input';

import { ISaveFavoriteOrderProps } from './types';
/**
 *
 * Save Favorite Order
 *
 *
 */
const SaveFavoriteOrder: FC<React.PropsWithChildren<ISaveFavoriteOrderProps>> = ({
  showDialog,
  onSave,
  onDismiss,
}) => {
  const { formatMessage } = useIntl();
  const [favoriteName, setFavoriteName] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleSave = () => {
    if (!favoriteName || favoriteName.trim() === '') {
      return setErrorMessage(formatMessage({ id: 'saveFavoriteOrderNameError' }));
    }
    onSave(favoriteName);
  };

  return (
    <Dialog
      showDialog={showDialog}
      testID="save-favorite-order"
      showCloseButton
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Save Favorite Order"
      heading={formatMessage({ id: 'nameYourFavorite' })}
      actions={
        <ActionButton fullWidth onPress={handleSave} testID="save-favorite-order-button">
          {formatMessage({ id: 'saveFavoriteOrderButton' })}
        </ActionButton>
      }
    >
      <Text>{formatMessage({ id: 'saveFavoriteOrderText' })}</Text>
      <Box marginBottom={{ base: '$1.5', md: '$2' }}>
        <FavoriteInput
          errorMessage={errorMessage}
          onChange={setFavoriteName}
          testID="save-favorite-order-name"
          favoriteName={favoriteName}
        />
      </Box>
    </Dialog>
  );
};

export default SaveFavoriteOrder;
